var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _g2, _g3, _path24, _path25, _path26, _path27, _path28, _g4, _path29, _g5, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoInternet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 115,
    viewBox: "0 0 291 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M58.5102 12.418H81.572",
    stroke: "white",
    strokeWidth: 3.54824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.047 99.3594L163.218 100.16L164.557 106.566L168.616 105.717L167.047 99.3594Z",
    fill: "#8A92A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.042 101.714L170.927 100.654",
    stroke: "#AAB9E1",
    strokeWidth: 0.706311,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.396 104.184L171.28 103.125",
    stroke: "#AAB9E1",
    strokeWidth: 0.706311,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.264 104.63C169.725 103.229 169.302 101.2 168.318 100.1C167.334 99.0011 166.163 99.2448 165.702 100.646C165.241 102.048 165.666 104.076 166.65 105.176C167.633 106.275 168.803 106.031 169.264 104.63Z",
    fill: "#8A92A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.666 105.354C166.127 103.954 165.702 101.925 164.719 100.826C163.735 99.7248 162.565 99.9697 162.104 101.371C161.644 102.773 162.067 104.802 163.05 105.901C164.034 107.001 165.204 106.757 165.666 105.356",
    fill: "#8A92A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.288 104.221C164.474 103.655 164.303 102.837 163.906 102.391C163.508 101.947 163.036 102.046 162.85 102.613C162.662 103.179 162.834 103.997 163.231 104.443C163.629 104.887 164.101 104.789 164.288 104.221Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.963 105.999C114.846 102.173 122.09 99.9551 127.696 99.3464C139.312 98.0832 145.643 99.8407 146.691 104.617C146.85 105.341 146.778 106.096 146.485 106.777C146.193 107.458 145.695 108.03 145.06 108.413C138.788 112.204 133.886 112.877 130.357 110.434C124.59 106.442 127.696 97.1289 137.451 97.1289C147.209 97.1289 151.2 105.111 156.523 104.224C160.07 103.633 162.435 103.337 163.619 103.337",
    stroke: "#8A92A8",
    strokeWidth: 0.886773,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9324 0.242188H101.726C102.489 0.242187 103.243 0.392329 103.948 0.68404C104.652 0.97575 105.292 1.40332 105.831 1.94233C106.37 2.48134 106.797 3.12124 107.089 3.82549C107.381 4.52974 107.531 5.28455 107.531 6.04683V108.577C107.531 110.117 106.919 111.593 105.831 112.682C104.742 113.77 103.266 114.382 101.726 114.382H80.9324V0.242188Z",
    fill: "#E4EFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5905 0C37.0512 0.000303428 35.575 0.611996 34.4867 1.70055C33.3984 2.78909 32.787 4.26536 32.787 5.80464V108.335C32.787 109.874 33.3984 111.351 34.4867 112.439C35.575 113.528 37.0512 114.139 38.5905 114.14H83.3616C84.9011 114.14 86.3776 113.528 87.4661 112.44C88.5547 111.351 89.1663 109.875 89.1663 108.335V5.80464C89.1663 4.26516 88.5547 2.78872 87.4661 1.70014C86.3776 0.611559 84.9011 0 83.3616 0L38.5905 0Z",
    fill: "url(#paint0_linear_7935_88946)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.787 91.3612H89.1651V90.4744H32.787V91.3612ZM32.787 69.1861H89.1651V68.2994H32.787V69.1861ZM32.787 46.1243H89.1651V45.2375H32.787V46.1243ZM32.787 23.9493H89.1651V23.0625H32.787V23.9493Z",
    fill: "url(#paint1_linear_7935_88946)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.7985 10.6426H42.5437C41.5642 10.6426 40.7702 11.4366 40.7702 12.4161V12.4173C40.7702 13.3968 41.5642 14.1908 42.5437 14.1908H79.7985C80.778 14.1908 81.5721 13.3968 81.5721 12.4173V12.4161C81.5721 11.4366 80.778 10.6426 79.7985 10.6426Z",
    fill: "#A6BCE4",
    fillOpacity: 0.441
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.737 80.7227H183.931C181.579 80.7227 179.673 82.6289 179.673 84.9803V99.8815C179.673 102.233 181.579 104.139 183.931 104.139H191.737C194.088 104.139 195.994 102.233 195.994 99.8815V84.9803C195.994 82.6289 194.088 80.7227 191.737 80.7227Z",
    fill: "#BDDEF5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M190.318 80.7227H182.512C180.161 80.7227 178.254 82.6289 178.254 84.9803V99.8815C178.254 102.233 180.161 104.139 182.512 104.139H190.318C192.669 104.139 194.576 102.233 194.576 99.8815V84.9803C194.576 82.6289 192.669 80.7227 190.318 80.7227Z",
    fill: "url(#paint2_linear_7935_88946)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.528 97.0431C188.076 97.0431 190.141 94.9781 190.141 92.4307C190.141 89.8834 188.076 87.8184 185.528 87.8184C182.981 87.8184 180.916 89.8834 180.916 92.4307C180.916 94.9781 182.981 97.0431 185.528 97.0431Z",
    fill: "#C8CED0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M186.415 97.0431C188.962 97.0431 191.027 94.9781 191.027 92.4307C191.027 89.8834 188.962 87.8184 186.415 87.8184C183.868 87.8184 181.803 89.8834 181.803 92.4307C181.803 94.9781 183.868 97.0431 186.415 97.0431Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M185.785 91.2303C185.785 90.9143 185.528 90.6582 185.212 90.6582C184.896 90.6582 184.64 90.9143 184.64 91.2303V93.6343C184.64 93.9503 184.896 94.2064 185.212 94.2064C185.528 94.2064 185.785 93.9503 185.785 93.6343V91.2303Z",
    fill: "#C8CED0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M187.914 91.2303C187.914 90.9143 187.658 90.6582 187.342 90.6582C187.026 90.6582 186.77 90.9143 186.77 91.2303V93.6343C186.77 93.9503 187.026 94.2064 187.342 94.2064C187.658 94.2064 187.914 93.9503 187.914 93.6343V91.2303Z",
    fill: "#C8CED0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4316 31.9375H41.6569C40.6774 31.9375 39.8833 32.7315 39.8833 33.711V35.4857C39.8833 36.4652 40.6774 37.2593 41.6569 37.2593H43.4316C44.4111 37.2593 45.2051 36.4652 45.2051 35.4857V33.711C45.2051 32.7315 44.4111 31.9375 43.4316 31.9375Z",
    fill: "url(#paint3_linear_7935_88946)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3813 33.7109H66.4934C66.0037 33.7109 65.6066 34.108 65.6066 34.5977V35.4856C65.6066 35.9754 66.0037 36.3724 66.4934 36.3724H67.3813C67.8711 36.3724 68.2681 35.9754 68.2681 35.4856V34.5977C68.2681 34.108 67.8711 33.7109 67.3813 33.7109Z",
    fill: "url(#paint4_linear_7935_88946)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1715 33.7109H60.2836C59.7938 33.7109 59.3968 34.108 59.3968 34.5977V35.4856C59.3968 35.9754 59.7938 36.3724 60.2836 36.3724H61.1715C61.6612 36.3724 62.0583 35.9754 62.0583 35.4856V34.5977C62.0583 34.108 61.6612 33.7109 61.1715 33.7109Z",
    fill: "url(#paint5_linear_7935_88946)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5899 33.7109H72.702C72.2122 33.7109 71.8152 34.108 71.8152 34.5977V35.4856C71.8152 35.9754 72.2122 36.3724 72.702 36.3724H73.5899C74.0797 36.3724 74.4767 35.9754 74.4767 35.4856V34.5977C74.4767 34.108 74.0797 33.7109 73.5899 33.7109Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7985 33.7109H78.9105C78.4208 33.7109 78.0238 34.108 78.0238 34.5977V35.4856C78.0238 35.9754 78.4208 36.3724 78.9105 36.3724H79.7985C80.2882 36.3724 80.6852 35.9754 80.6852 35.4856V34.5977C80.6852 34.108 80.2882 33.7109 79.7985 33.7109Z",
    fill: "url(#paint6_linear_7935_88946)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M43.4316 54.9941H41.6569C40.6774 54.9941 39.8833 55.7882 39.8833 56.7677V58.5424C39.8833 59.5219 40.6774 60.3159 41.6569 60.3159H43.4316C44.4111 60.3159 45.2051 59.5219 45.2051 58.5424V56.7677C45.2051 55.7882 44.4111 54.9941 43.4316 54.9941Z",
    fill: "url(#paint7_linear_7935_88946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M67.3813 56.7676H66.4934C66.0037 56.7676 65.6066 57.1646 65.6066 57.6544V58.5423C65.6066 59.032 66.0037 59.429 66.4934 59.429H67.3813C67.8711 59.429 68.2681 59.032 68.2681 58.5423V57.6544C68.2681 57.1646 67.8711 56.7676 67.3813 56.7676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.1715 56.7676H60.2836C59.7938 56.7676 59.3968 57.1646 59.3968 57.6544V58.5423C59.3968 59.032 59.7938 59.429 60.2836 59.429H61.1715C61.6612 59.429 62.0583 59.032 62.0583 58.5423V57.6544C62.0583 57.1646 61.6612 56.7676 61.1715 56.7676Z",
    fill: "url(#paint8_linear_7935_88946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M73.5899 56.7676H72.702C72.2122 56.7676 71.8152 57.1646 71.8152 57.6544V58.5423C71.8152 59.032 72.2122 59.429 72.702 59.429H73.5899C74.0797 59.429 74.4767 59.032 74.4767 58.5423V57.6544C74.4767 57.1646 74.0797 56.7676 73.5899 56.7676Z",
    fill: "url(#paint9_linear_7935_88946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.7985 56.7676H78.9105C78.4208 56.7676 78.0238 57.1646 78.0238 57.6544V58.5423C78.0238 59.032 78.4208 59.429 78.9105 59.429H79.7985C80.2882 59.429 80.6852 59.032 80.6852 58.5423V57.6544C80.6852 57.1646 80.2882 56.7676 79.7985 56.7676Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.4316 77.1719H41.6569C40.6774 77.1719 39.8833 77.9659 39.8833 78.9454V80.7201C39.8833 81.6996 40.6774 82.4937 41.6569 82.4937H43.4316C44.4111 82.4937 45.2051 81.6996 45.2051 80.7201V78.9454C45.2051 77.9659 44.4111 77.1719 43.4316 77.1719Z",
    fill: "url(#paint10_linear_7935_88946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M67.3813 78.9453H66.4934C66.0037 78.9453 65.6066 79.3423 65.6066 79.8321V80.72C65.6066 81.2098 66.0037 81.6068 66.4934 81.6068H67.3813C67.8711 81.6068 68.2681 81.2098 68.2681 80.72V79.8321C68.2681 79.3423 67.8711 78.9453 67.3813 78.9453Z",
    fill: "url(#paint11_linear_7935_88946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M61.1715 78.9453H60.2836C59.7938 78.9453 59.3968 79.3423 59.3968 79.8321V80.72C59.3968 81.2098 59.7938 81.6068 60.2836 81.6068H61.1715C61.6612 81.6068 62.0583 81.2098 62.0583 80.72V79.8321C62.0583 79.3423 61.6612 78.9453 61.1715 78.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M73.5899 78.9453H72.702C72.2122 78.9453 71.8152 79.3423 71.8152 79.8321V80.72C71.8152 81.2098 72.2122 81.6068 72.702 81.6068H73.5899C74.0797 81.6068 74.4767 81.2098 74.4767 80.72V79.8321C74.4767 79.3423 74.0797 78.9453 73.5899 78.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M79.7985 78.9453H78.9105C78.4208 78.9453 78.0238 79.3423 78.0238 79.8321V80.72C78.0238 81.2098 78.4208 81.6068 78.9105 81.6068H79.7985C80.2882 81.6068 80.6852 81.2098 80.6852 80.72V79.8321C80.6852 79.3423 80.2882 78.9453 79.7985 78.9453Z",
    fill: "url(#paint12_linear_7935_88946)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.4316 98.457H41.6569C40.6774 98.457 39.8833 99.2511 39.8833 100.231V102.005C39.8833 102.985 40.6774 103.779 41.6569 103.779H43.4316C44.4111 103.779 45.2051 102.985 45.2051 102.005V100.231C45.2051 99.2511 44.4111 98.457 43.4316 98.457Z",
    fill: "url(#paint13_linear_7935_88946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M67.3813 100.23H66.4934C66.0037 100.23 65.6066 100.627 65.6066 101.117V102.005C65.6066 102.495 66.0037 102.892 66.4934 102.892H67.3813C67.8711 102.892 68.2681 102.495 68.2681 102.005V101.117C68.2681 100.627 67.8711 100.23 67.3813 100.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.1715 100.23H60.2836C59.7938 100.23 59.3968 100.627 59.3968 101.117V102.005C59.3968 102.495 59.7938 102.892 60.2836 102.892H61.1715C61.6612 102.892 62.0583 102.495 62.0583 102.005V101.117C62.0583 100.627 61.6612 100.23 61.1715 100.23Z",
    fill: "url(#paint14_linear_7935_88946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.5899 100.23H72.702C72.2122 100.23 71.8152 100.627 71.8152 101.117V102.005C71.8152 102.495 72.2122 102.892 72.702 102.892H73.5899C74.0797 102.892 74.4767 102.495 74.4767 102.005V101.117C74.4767 100.627 74.0797 100.23 73.5899 100.23Z",
    fill: "url(#paint15_linear_7935_88946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79.7985 100.23H78.9105C78.4208 100.23 78.0238 100.627 78.0238 101.117V102.005C78.0238 102.495 78.4208 102.892 78.9105 102.892H79.7985C80.2882 102.892 80.6852 102.495 80.6852 102.005V101.117C80.6852 100.627 80.2882 100.23 79.7985 100.23Z",
    fill: "white"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M221.393 79.4766H214.276C212.911 79.4766 211.804 80.5831 211.804 81.9481C211.804 83.3131 212.911 84.4196 214.276 84.4196H221.393C222.758 84.4196 223.864 83.3131 223.864 81.9481C223.864 80.5831 222.758 79.4766 221.393 79.4766Z",
    fill: "#F5AB34"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M220.898 79.4766H210.023C209.696 79.4766 209.431 79.7419 209.431 80.0693V80.0704C209.431 80.3978 209.696 80.6631 210.023 80.6631H220.898C221.226 80.6631 221.491 80.3978 221.491 80.0704V80.0693C221.491 79.7419 221.226 79.4766 220.898 79.4766Z",
    fill: "#F5AB34"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7935_88946",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 219,
    y: 57,
    width: 31,
    height: 51
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M234.53 57.4492C226.005 57.4492 219.095 64.3592 219.095 72.8825V92.2462C219.095 100.771 226.006 107.681 234.53 107.681H249.963V72.8825C249.963 64.358 243.053 57.4492 234.53 57.4492Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7935_88946)"
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M234.53 57.4492C226.005 57.4492 219.095 64.3592 219.095 72.8825V92.2462C219.095 100.771 226.006 107.681 234.53 107.681H249.963V72.8825C249.963 64.358 243.053 57.4492 234.53 57.4492Z",
    fill: "url(#paint16_linear_7935_88946)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7935_88946",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 207,
    y: 96,
    width: 49,
    height: 7
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M255.331 96.4551H207.977V102.59H255.331V96.4551Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7935_88946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.331 96.4551H207.977V102.59H255.331V96.4551Z",
    fill: "#1473E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.331 101.441H207.977V107.577H255.331V101.441Z",
    fill: "#0C54AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7935_88946",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 207,
    y: 87,
    width: 49,
    height: 7
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M255.331 87.832H207.977V93.9674H255.331V87.832Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7935_88946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.331 87.832H207.977V93.9674H255.331V87.832Z",
    fill: "#1473E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.331 92.8164H207.977V98.9517H255.331V92.8164Z",
    fill: "#3126CD"
  })))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M223.981 74.2569C222.256 74.2569 220.858 72.8589 220.858 71.1343C220.858 69.4097 222.256 68.0117 223.981 68.0117C225.705 68.0117 227.103 69.4097 227.103 71.1343C227.103 72.8589 225.705 74.2569 223.981 74.2569Z",
    fill: "url(#paint17_linear_7935_88946)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M222.805 71.4271C222.173 71.4271 221.66 70.9148 221.66 70.2829C221.66 69.651 222.173 69.1387 222.805 69.1387C223.437 69.1387 223.949 69.651 223.949 70.2829C223.949 70.9148 223.437 71.4271 222.805 71.4271Z",
    fill: "#131212"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M230.116 74.2569C228.392 74.2569 226.994 72.8589 226.994 71.1343C226.994 69.4097 228.392 68.0117 230.116 68.0117C231.841 68.0117 233.239 69.4097 233.239 71.1343C233.239 72.8589 231.841 74.2569 230.116 74.2569Z",
    fill: "url(#paint18_linear_7935_88946)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M228.94 71.4271C228.308 71.4271 227.796 70.9148 227.796 70.2829C227.796 69.651 228.308 69.1387 228.94 69.1387C229.572 69.1387 230.084 69.651 230.084 70.2829C230.084 70.9148 229.572 71.4271 228.94 71.4271Z",
    fill: "#131212"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M229.256 79.1167C228.638 78.3501 227.963 77.9668 227.232 77.9668C226.502 77.9668 225.899 78.3501 225.422 79.1167",
    stroke: "#FF6830",
    strokeWidth: 1.53326,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M237.883 83.5174C237.883 82.2997 238.87 81.3125 240.088 81.3125C241.306 81.3125 242.293 82.2997 242.293 83.5174V90.9938C242.293 92.2115 241.306 93.1987 240.088 93.1987C238.87 93.1987 237.883 92.2115 237.883 90.9938V83.5174Z",
    fill: "#FFCD1A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M227.8 62.9237C229.08 55.6785 228.26 51.5822 225.343 50.6348M226.955 63.0095C223.195 55.8037 221.782 54.0379 220.82 52.0822L226.955 63.0095Z",
    stroke: "black",
    strokeWidth: 0.572112
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M224.655 51.5892C224.023 51.5892 223.511 51.0769 223.511 50.445C223.511 49.8131 224.023 49.3008 224.655 49.3008C225.287 49.3008 225.799 49.8131 225.799 50.445C225.799 51.0769 225.287 51.5892 224.655 51.5892Z",
    fill: "#010101"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M220.819 53.3119C220.187 53.3119 219.675 52.7996 219.675 52.1677C219.675 51.5357 220.187 51.0234 220.819 51.0234C221.451 51.0234 221.964 51.5357 221.964 52.1677C221.964 52.7996 221.451 53.3119 220.819 53.3119Z",
    fill: "#010101"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.884,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.193 90.1285H255.81C254.259 90.1285 252.772 89.5125 251.675 88.416C250.579 87.3194 249.963 85.8322 249.963 84.2815V79.2012H256.192C257.641 79.2012 259.031 79.7768 260.055 80.8014C261.08 81.8261 261.656 83.2158 261.656 84.6648C261.656 86.1139 261.08 87.5036 260.055 88.5282C259.031 89.5529 257.641 90.1285 256.192 90.1285H256.193Z",
    fill: "#FA9766"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.884,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.193 70.5723H255.81C254.259 70.5723 252.772 71.1883 251.675 72.2848C250.579 73.3813 249.963 74.8685 249.963 76.4192V81.4996H256.192C257.641 81.4996 259.031 80.924 260.055 79.8993C261.08 78.8747 261.656 77.485 261.656 76.0359C261.656 74.5869 261.08 73.1972 260.055 72.1725C259.031 71.1479 257.641 70.5723 256.192 70.5723H256.193Z",
    fill: "#FA9766"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.318,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 113.012H291V114.424H0V113.012Z",
    fill: "#D8DDEC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7935_88946",
    x1: 54.0989,
    y1: 5.94618e-7,
    x2: 97.4897,
    y2: 93.4233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7935_88946",
    x1: 60.9761,
    y1: 23.0625,
    x2: 60.9761,
    y2: 91.3612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7935_88946",
    x1: 182.451,
    y1: 80.7227,
    x2: 194.717,
    y2: 99.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7935_88946",
    x1: 42.5442,
    y1: 31.9375,
    x2: 42.5442,
    y2: 37.2593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7935_88946",
    x1: 66.9374,
    y1: 33.7109,
    x2: 66.9374,
    y2: 36.3724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7935_88946",
    x1: 60.7275,
    y1: 33.7109,
    x2: 60.7275,
    y2: 36.3724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7935_88946",
    x1: 79.3545,
    y1: 33.7109,
    x2: 79.3545,
    y2: 36.3724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7935_88946",
    x1: 42.5442,
    y1: 54.9941,
    x2: 42.5442,
    y2: 60.3159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7935_88946",
    x1: 60.7275,
    y1: 56.7676,
    x2: 60.7275,
    y2: 59.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7935_88946",
    x1: 73.1459,
    y1: 56.7676,
    x2: 73.1459,
    y2: 59.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7935_88946",
    x1: 42.5442,
    y1: 77.1719,
    x2: 42.5442,
    y2: 82.4937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7935_88946",
    x1: 66.9374,
    y1: 78.9453,
    x2: 66.9374,
    y2: 81.6068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7935_88946",
    x1: 79.3545,
    y1: 78.9453,
    x2: 79.3545,
    y2: 81.6068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7935_88946",
    x1: 42.5442,
    y1: 98.457,
    x2: 42.5442,
    y2: 103.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7935_88946",
    x1: 60.7275,
    y1: 100.23,
    x2: 60.7275,
    y2: 102.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7935_88946",
    x1: 73.1459,
    y1: 100.23,
    x2: 73.1459,
    y2: 102.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7935_88946",
    x1: 234.529,
    y1: 57.4492,
    x2: 234.529,
    y2: 107.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7935_88946",
    x1: 221.606,
    y1: 69.3391,
    x2: 223.981,
    y2: 71.1343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7935_88946",
    x1: 227.742,
    y1: 69.3391,
    x2: 231.665,
    y2: 74.2569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternet);
export default __webpack_public_path__ + "static/media/noInternet.6f83b337fc79a6f9d53b1b9f49b17eb0.svg";
export { ForwardRef as ReactComponent };